import { useCallback } from 'react';
import { Modal } from 'antd';
import { ApolloError } from '@apollo/client';

// several media requests can fail in a row: show a single modal at a time
let modalVisible = false;

export function isDeviceDisabled(error: ApolloError) {
  return error.graphQLErrors.some((e) => e.extensions?.['code'] === 'DEVICE_IS_DISABLED');
}

export function useHandleDeviceDisabledError() {
  return useCallback((e: ApolloError) => {
    if (!isDeviceDisabled(e) || modalVisible) return;
    modalVisible = true;
    Modal.error({
      title: 'Hai superato il numero massimo di dispositivi',
      content: (
        <>
          Contatta l'assistenza: <a href="mailto:app@progettisonori.it">app@progettisonori.it</a> -{' '}
          <a href="tel:+390722816895">0722816895</a>
        </>
      ),
      okText: 'Chiudi',
      afterClose: () => {
        modalVisible = false;
      },
    });
  }, []);
}
